
import { QtCategory } from '../domain/QtCategory'
import { useQuery } from 'react-query'
import { QtCategoryRepository } from '../domain/repository/QtCategoryRepository'

interface QueryOptions {
    onSuccess?: (params: QtCategory[]) => void
    onError?: () => void
}

export const useQtCategoryFindAllQuery = (
    qtCategoryRepository: QtCategoryRepository,
    {
        onSuccess,
        onError,
    }: {
        onSuccess?: (qtCategories: QtCategory[]) => void
        onError?: (error: unknown) => void
    } = {}
) => {
    return useQuery('qt-categories-find-all-query', () => qtCategoryRepository.findAll(), {
        staleTime: 0,
        onSuccess,
        onError,
    })
}